import React, { useState, useEffect } from 'react';

const ITEM_NAMES = {
  USDT: { name: 'تتر (USDT)', icon: '💵' },
  XAUT: { name: 'انس طلا (XAUT)', icon: '🪙' },
  ID2: { name: 'سکه تمام طرح جدید', icon: '🟡' },
  ID3: { name: 'سکه تمام طرح قدیم', icon: '🟡' },
  ID4: { name: 'نیم سکه', icon: '🌗' },
  ID5: { name: 'ربع سکه', icon: '🌘' },
  ID6: { name: 'آبشده نقد فردا', icon: '✨' },
  ID7: { name: 'آبشده نقد فردا (گرم)', icon: '✨' },
  ID8: { name: 'آبشده نقد پس فردا', icon: '🔱' },
  ID11: { name: 'تمام سکه ۱۴۰۳', icon: '🟡' },
  ID17: { name: 'طلای ۱۸ عیار', icon: '🔘' },
};

export default function Prices() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState(null);

  const fetchPrices = (isInitial = false) => {
    if (isInitial) {
      setLoading(true);
    } else {
      setRefreshing(true);
    }
    setError(null);

    fetch('https://api.ksgold.ir/api/prices/?format=json')
      .then((res) => {
        if (!res.ok) throw new Error('خطا در دریافت اطلاعات');
        return res.json();
      })
      .then((data) => {
        setData(data);
        setLoading(false);
        setRefreshing(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
        setRefreshing(false);
      });
  };

  useEffect(() => {
    fetchPrices(true);
  }, []);

  const formatNumber = (num) => {
    if (num === undefined || num === null || isNaN(num) || num === 0) return '-';
    return Number(num).toLocaleString('fa-IR');
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center p-12 text-slate-600 font-medium dir-rtl">
        در حال دریافت آخرین قیمت‌ها...
      </div>
    );
  }

  if (error && !data) {
    return (
      <div className="flex justify-center items-center p-12 text-red-500 font-medium dir-rtl">
        {error}
      </div>
    );
  }

  return (
    <div className="dir-rtl max-w-5xl my-8 mx-auto p-6 bg-white rounded-2xl shadow-lg border border-slate-100">
      {/* هدر شامل عنوان و دکمه بروزرسانی */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="m-0 text-slate-800 text-xl font-bold">
          قیمت لحظه‌ای طلا، سکه و ارز
        </h2>
        <button
          onClick={() => fetchPrices(false)}
          disabled={refreshing}
          className="bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 disabled:opacity-70 disabled:cursor-not-allowed flex items-center gap-2 shadow-sm"
        >
          {refreshing ? (
            <>
              <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span>در حال بروزرسانی...</span>
            </>
          ) : (
            'بروزرسانی قیمت‌ها'
          )}
        </button>
      </div>

      {/* کانتینر جدول با قابلیت اسکرول افقی روی موبایل */}
      <div className="overflow-x-auto min-w-full">
        <div className="min-w-[650px]">
          {/* هدر ۵ ستونه */}
          <div className="grid grid-cols-6 gap-2 items-center px-4 py-3 bg-slate-50 rounded-lg font-bold text-slate-600 text-sm mb-2 text-center">
            <div className="col-span-2 text-right">عنوان دارایی</div>
            <div>خرید عادی</div>
            <div>خرید همکار</div>
            <div>فروش عادی</div>
            <div>فروش همکار</div>
          </div>

          {/* لیست قیمت‌ها */}
          <div className="divide-y divide-slate-100">
            {data &&
              Object.entries(data).map(([key, item]) => {
                const itemInfo = ITEM_NAMES[key] || { name: key, icon: '💎' };

                const buyNormal = item.BuyPriceNormal ?? item[`${key}_BUY_NORMAL`];
                const buyColleague = item.BuyPriceColleague ?? item[`${key}_BUY_COLLEAGUE`];
                const sellNormal = item.SellPriceNormal ?? item[`${key}_SELL_NORMAL`];
                const sellColleague = item.SellPriceColleague ?? item[`${key}_SELL_COLLEAGUE`];

                return (
                  <div
                    key={key}
                    className="grid grid-cols-6 gap-2 items-center px-4 py-3 text.sm text-center hover:bg-slate-50/80 transition-colors"
                  >
                    <div className="col-span-2 flex items-center gap-2 text-slate-900 font-semibold text-right">
                      <span>{itemInfo.icon}</span>
                      <span>{itemInfo.name}</span>
                    </div>

                    <div className="text-emerald-600 font-medium">{formatNumber(buyNormal)}</div>
                    <div className="text-emerald-700 font-medium">{formatNumber(buyColleague)}</div>
                    <div className="text-sky-600 font-medium">{formatNumber(sellNormal)}</div>
                    <div className="text-indigo-600 font-medium">{formatNumber(sellColleague)}</div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}